import React from 'react'
import FlexContainer from 'core-system/FlexContainer'
import Text from 'core-system/Text'
import palette from 'core-system/Themes/palette'
import styled from 'styled-components'
import Chip from 'core-system/Chip'
import { SwitchToggleV2 } from 'core-system/SwitchToggle'

interface TransitParkingToggleProps {
  type: 'Transit' | 'Parking'
  icon: React.ReactNode
  canEdit: boolean
  active: boolean
  handleToggle: (type: 'parking' | 'transit') => void
}

const IconContainer = styled.div`
  min-width: 2.5rem;
  height: 2.5rem;
  background-color: ${(props) => props.theme.palette.secondary.purple600};
  border-radius: 0.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
`

const TransitParkingToggle = ({
  type,
  icon,
  canEdit,
  active,
  handleToggle,
}: TransitParkingToggleProps) => {
  return (
    <FlexContainer
      alignItems='center'
      marginBottom='1rem'
      justifyContent='space-between'
    >
      <FlexContainer>
        <IconContainer>{icon}</IconContainer>
        <FlexContainer
          flexDirection='column'
          marginLeft='1rem'
          justifyContent='center'
        >
          <Text variant='h5' color={palette.black}>
            {type}{' '}
          </Text>
        </FlexContainer>
      </FlexContainer>
      {canEdit ? (
        <SwitchToggleV2
          active={active}
          onClick={() =>
            handleToggle(type.toLowerCase() as 'parking' | 'transit')
          }
        />
      ) : (
        <Chip variant={active ? 'green' : 'grey'}>
          {active ? 'Active' : 'Disabled'}
        </Chip>
      )}
    </FlexContainer>
  )
}

export default React.memo(TransitParkingToggle)
